import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';


import { API_LINK } from '../../constants';
import moment from 'moment';
import { turnitinDoSubmissionFailure, turnitinDoSubmissionRequest, turnitinDoSubmissionSuccess, turnitinReportFailure, turnitinReportRequest, turnitinReportSuccess } from '../reducers/turnitin';

const API = `${API_LINK}api`;



function* turnitinReportFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { status, row } = state.markerReducer;
  const { statementid } = state.turnitinReducer;
  const {
    user,
    token,
  } = state.loginReducer;

  var names = row.thisRow.name.split(' ')

  const response = yield call(() =>
    axios({
      method: 'put',
      url: API+'/assessor/tii_ReportReport',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Uploaaded-With': 'XMLHttpUploaad',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        statementid: statementid,
      },
    }),
  );

  return response;
}

function* workerTurnitinReportSaga() {
  try {
   
    const response = yield call(turnitinReportFunctionAxios);
    const responseFromTurnitinReport = response.data;
   
    if (response.status === 200) {
      yield put(turnitinReportSuccess(responseFromTurnitinReport));
    }
    if (response.status === 201) {
      yield put(turnitinReportFailure(responseFromTurnitinReport.message));
    }
  } catch (error) {
    yield put(turnitinReportFailure(error.message));
  }
}

export function* watcherTurnitinReportSaga() {
 
  yield takeLatest(turnitinReportRequest().type, workerTurnitinReportSaga);
}
